export enum CorporateActionDirectiveType {
  kapCustomAmount = 'BEZUG_AKTIEN_WIE_ANGEGEBEN',
  kapDefault = 'BEZUG_AKTIEN_GEM_BZR_BESTAND',
  teilrechtKauf = 'TEILRECHT_KAUF_BRUCHSTUECKE',
  teilrechtVerkauf = 'TEILRECHT_VERKAUF_BRUCHSTUECKE',
  wdivStock = 'BEZUG_STOCKDIVIDENDE',
}
